import React, { Component } from "react";
import { Collapse, CardBody, Card } from "reactstrap";
import { Button } from "mdbreact";

class CollapsibleMenu extends Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = { collapse: false };
  }

  toggle() {
    this.setState({ collapse: !this.state.collapse });
  }

  render() {
    return (
      <div>
        <style>
          {`
              @media only screen and (min-width : 321px) {

              }

              /* Smartphones (portrait) ----------- */
              @media only screen and (max-width : 700px) {
                button{
                  width:100%;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }`}
        </style>
        <Button
          color="info"
          onClick={this.toggle}
          style={{ marginBottom: "1rem", width: "400px", textAlign: "center" }}
        >
          {this.props.title}
        </Button>
        <Collapse isOpen={this.state.collapse}>
          <Card style={{ padding: "1rem", overflow: "auto" }}>
            <CardBody>{this.props.content}</CardBody>
          </Card>
        </Collapse>
        <br />
      </div>
    );
  }
}

export default CollapsibleMenu;
